import { Component, Inject, OnInit } from '@angular/core';
import { ModalData, ModalRef } from '@purespectrum1/ui/modal';
import { ToasterService } from '@purespectrum1/ui/toaster-service';
import { notifyMessage } from '../../../shared/constants/notify-message';
import { SurveyService } from '../../../shared/services/survey/survey.service';

@Component({
  selector: 'ps-ui-clear-upload-modal',
  templateUrl: './clear-upload-modal.component.html',
  styleUrls: ['./clear-upload-modal.component.css'],
})
export class ClearUploadModalComponent implements OnInit {
  psidFilePath = '';
  constructor(
    @Inject(ModalData) private _modalData: string,
    private _modalRef: ModalRef<ClearUploadModalComponent, string>,
    private _surveyService: SurveyService,
    private _toastr: ToasterService
  ) {}

  ngOnInit(): void {
    this.psidFilePath = this._modalData;
  }

  close(msg = '') {
    this._modalRef.close(msg);
  }

  clear() {
    this._surveyService.clearUploadedPSIDbyPath(this.psidFilePath).subscribe(
      (res) => {
        this._toastr.success(notifyMessage.successMessage.PSID_CLEAR_SUCCESS);
        this.close('Clear');
      },
      (error) => {
        this._toastr.error(notifyMessage.errorMessage.API_ERROR);
      }
    );
  }
}
